import gql from "graphql-tag";

export const MY_LEAVE_CREATE_MESSAGE = gql`
  mutation createLeaveMessage(
    $request: String!
    $message: String!
    $locale: String!
    $role: String
  ) {
    createLeaveMessage(
      request: $request
      message: $message
      locale: $locale
      role: $role
    ) {
      createdAt
      createdBy
      message
      employeeName
      employeeAvatar
    }
  }
`;
